import { FlowstepType } from 'shared/utils/flowstep';
import { PushFlowstep } from 'src/services/runtime/pushFlowstep';


export class DeleteFlowstep extends PushFlowstep {
  constructor(flowstep, meta, parent) {
    super(flowstep, meta, parent);
  }

  get deleteRowsInTable() { return this.flowstep.type === FlowstepType.Delete && !!this.flowstep.options.deleteRowsInTable; }
  get disableFilters() { return this.deleteRowsInTable; }

  async _processChunk_(values) {
    const chunkDataSourceTree = this.dataSourceTree.pickCount(values.length);
    // console.log('Delete. Chunk visible rows spans tree: ', chunkDataSourceTree);
    // console.log('Delete. Values: ', values);

    // Reverse values and tree back
    chunkDataSourceTree.reverse(this.dataBodyRowCount);
    values.reverse();

    // insert only those, which have errors
    const criteria = (row) => this.errorMapper(row);
    const { resultErrorsOrEmpty, hasErrors } = this.collectResultErrors(values, chunkDataSourceTree, criteria);

    if (!this.deleteRowsInTable) {
      if (this.showResultsTable) {
        for (const rangeTree of chunkDataSourceTree.children) {
          this.resultsTable
            .getRows(rangeTree.index, rangeTree.count)
            .getVisibleView()
            .values = values.splice(0, rangeTree.getValuesCount());
        }
      }

      return;
    }

    const valuesToInsert = values.filter((x, i) => !!resultErrorsOrEmpty[i]);
    const { toPick: treeToInsert, toLeft: treeToDelete } = chunkDataSourceTree.pickByCriteria(resultErrorsOrEmpty);

    // console.log('Criterias to insert: ', criteriasToInsert);
    // console.log('Tree to delete: ', treeToDelete);
    // console.log('Tree to insert: ', treeToInsert);

    // If we're here, then filters are disabled. We need to work with the latest level in the data tree
    // To do this we can flatten our tree

    if (!treeToInsert.isEmpty() && this.showResultsTable) {
      for (const { index, count } of treeToInsert.flatten()) {
        this.resultsTable
          .getRows(index, count)
          .values = valuesToInsert.splice(0, count);
      }
    }

    if (!treeToDelete.isEmpty()) {
      for (const { index, count } of treeToDelete.flatten().reverse()) {
        if (this.showResultsTable) {
          this.resultsTable.deleteRows(index, count);
        }
        this.dataTable.deleteRows(index, count);
      }
    }
  }

  async _applyFlowstepData_(headers) {
    const { idColumnName, batchSize, runSynchronously, parallelCount } = this.flowstep.options;
    const columnIndex = headers.findIndex(x => x === idColumnName);
    if (-1 === columnIndex) {
      throw new Error(`Unable to find column '${idColumnName}' to get IDs to delete`);
    }

    this.requestContext = { columnIndex };
    this.options = { batchSize, runSynchronously, parallelCount };
    return ['id'];
  }

  _loadValues_(range, rangeTree) {
    return range
      .getColumn(this.requestContext.columnIndex)
      .getVisibleView()
      .load(['values']);
  }

  _mapValues_(loadedRangeView) {
    return loadedRangeView.values.map(row => row[0]);
  }

  async _buildRequest_(objects) {
    this.dataBodyRowCount = this.dataTable.dataBodyRange.rowCount;
    this.dataSourceTree.reverse(this.dataBodyRowCount);
    return { objects: objects.reverse(), options: this.options };
  }
};

